import React, { useEffect, useState } from "react";

const Pagination = ({
  page,
  setPage,
  pages,
  next,
  displayPages,
  pageNumbers,
  previous,
}) => {
  return (
    <>
      {pages > 5 ? (
        <ul className="pagination">
          <li
            onClick={previous}
            className="fs14 lh-14 metro-m display-center page-item"
          >
            <img src="/images/pagi-left.svg" />
          </li>
          {displayPages.map((number) => {
            return (
              <li
                onClick={() => setPage(number)}
                key={number}
                className={
                  page == number
                    ? "fs14 lh-14 metro-m display-center page-item active"
                    : "fs14 lh-14 metro-m display-center page-item"
                }
              >
                {number}
              </li>
            );
          })}
          <li
            onClick={next}
            className="fs14 lh-14 metro-m display-center page-item"
          >
            <img src="/images/pagi-right.svg" />
          </li>
        </ul>
      ) : (
        <ul className="pagination">
          <li className="fs14 lh-14 metro-m display-center page-item">
            <img src="/images/pagi-left.svg" />
          </li>
          {pageNumbers &&
            pageNumbers.map((number) => {
              return (
                <li
                  onClick={() => setPage(number)}
                  key={number}
                  className={
                    page == number
                      ? "fs14 lh-14 metro-m display-center page-item active"
                      : "fs14 lh-14 metro-m display-center page-item"
                  }
                >
                  {number}
                </li>
              );
            })}
          <li className="fs14 lh-14 metro-m display-center page-item">
            <img src="/images/pagi-right.svg" />
          </li>
        </ul>
      )}
    </>
  );
};

export default Pagination;
